import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PlantmachineryService } from './plantmachinery.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-plantmachinery',
  templateUrl: './plantmachinery.component.html',
  styleUrls: ['./plantmachinery.component.scss']
})
export class PlantmachineryComponent implements OnInit {
  plantmachineryform: FormGroup;
  APPeriodId: any
  tangibleAssetsValidation: any;
  machineid: any; isJump: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, private machineservice: PlantmachineryService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) { }
  ngOnInit(): void {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.createplantmachinery();
    this.getmachinery(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          debugger  
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})


      this.clearfield();
    if (localStorage.getItem("SubmitStatus") == "true")
      this.plantmachineryform.disable()
  }

  createplantmachinery() {
    this.plantmachineryform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      PlantmachineryId: new FormControl(),
      PropertyPlantEquipmentGrossCost_End: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_End: new FormControl(),
      PropertyPlantEquipment_Start: new FormControl(),
      PropertyPlantEquipment_End: new FormControl(),
      TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment: new FormControl(),
      DisposalsPropertyPlantEquipment: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start: new FormControl(),
      IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      PropertyPlantEquipmentGrossCost_Start: new FormControl(),
      PropertyPlantEquipmentFreeøtextComment: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }
  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.plantmachineryform.reset()
      }
    })
  }
  Insertmachinery() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.plantmachineryform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.plantmachineryform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.plantmachineryform.getRawValue()
    if (this.machineid) {
      this.plantmachineryform.controls['PlantmachineryId'].setValue(this.machineid)
    }
    this.machineservice.insertmachinery(formdata).subscribe((data) => {
      this.plantmachineryform.markAsPristine();
      if(this.NormalRoutng)
      return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Plant Machinery", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'plantmachinery') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
}
  getmachinery(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.machineservice.getmachinery(this.APPeriodId).subscribe((data:any) => {
      if (data) {
        this.plantmachineryform.patchValue(data);
        this.machineid = data.PlantmachineryId
      }
      this.commonService.getNotesData();
      this.commonService.gettotaltanagable()
      this.plantmachineryform.controls['PropertyPlantEquipmentGrossCost_End'].disable();
      this.plantmachineryform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_End'].disable();
      this.plantmachineryform.controls['PropertyPlantEquipment_Start'].disable();
      this.plantmachineryform.controls['PropertyPlantEquipment_End'].disable();
      this.plantmachineryform.controls['TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment'].disable();
      this.plantmachineryform.controls['DisposalsPropertyPlantEquipment'].disable();
      this.plantmachineryform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start'].disable();
      this.plantmachineryform.controls['IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.plantmachineryform.controls['DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.plantmachineryform.controls['PropertyPlantEquipmentGrossCost_Start'].disable();
      this.costcalculation();
      this.depreciation();
    })

  }

  getlastyeardata() {
    this.machineservice.getmachineryLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
      this.plantmachineryform.controls['PropertyPlantEquipment_End'].setValue(data.PropertyPlantEquipment_End)


    })
  }
  save() {
    debugger
    //if (this.validations()) {
    if (true) {
      this.Insertmachinery();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }
  back() {
    debugger;
    this.plantmachineryform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Plant Machinery", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  costcalculation() {
    //const propertyPlantEquipmentGrossCost_End = +this.plantmachineryform.get("PropertyPlantEquipmentGrossCost_Start").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_End = +this.plantmachineryform.get("TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment").value;
    //const propertyPlantEquipment_Start = +this.plantmachineryform.get("DisposalsPropertyPlantEquipment").value;
    //const total = propertyPlantEquipmentGrossCost_End + accumulatedDepreciationImpairmentPropertyPlantEquipment_End;
    //this.plantmachineryform.get("PropertyPlantEquipmentGrossCost_End").setValue(total - propertyPlantEquipment_Start);
    //this.plantmachineryform.get("PropertyPlantEquipment_Start").setValue(this.plantmachineryform.get("PropertyPlantEquipmentGrossCost_End").value - this.plantmachineryform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }
  depreciation() {
    //const totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment = +this.plantmachineryform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start").value;
    //const disposalsPropertyPlantEquipment = +this.plantmachineryform.get("IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_Start = +this.plantmachineryform.get("DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const total = totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment + disposalsPropertyPlantEquipment;
    //this.plantmachineryform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").setValue(total - accumulatedDepreciationImpairmentPropertyPlantEquipment_Start);
    //this.plantmachineryform.get("PropertyPlantEquipment_Start").setValue(this.plantmachineryform.get("PropertyPlantEquipmentGrossCost_End").value - this.plantmachineryform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }


  validations() {
    debugger
    if (!this.commonService.MotorVehicles &&  !this.commonService.OfficeEquipment && !this.commonService.Furnitureandfittings) {
      if ((+this.plantmachineryform.controls["PropertyPlantEquipment_Start"].value + (+this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_Start))  !=
        +this.commonService.tangibleAssetsValidation.BalanceSheet_CY ){
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.EndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.StartYear + " both values must match. ", 'warning')
        return false
      }
      if ((+this.plantmachineryform.controls["PropertyPlantEquipment_End"].value + (+this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_End)) !=
        +this.commonService.tangibleAssetsValidation.BalanceSheet_LY) {
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.LastyearEndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.LastYear + " both values must match. ", 'warning')
        return false
      }
      else {
        return true
      }
    }
    else {
      return true
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.plantmachineryform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }
 
}
